module.exports = __webpack_public_path__ + "static/media/ServicesCollaborationIcon.27afdd69.svg";